/**
 * @since 2026-04-18
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import React, { useMemo } from "react";
import ReactECharts from "echarts-for-react";
import { applyDarkChartDefaults } from "./chartUtils";

const EChart = ({ option, height = 320 }) => {
  const themedOption = useMemo(() => applyDarkChartDefaults(option), [option]);
  return (
    <ReactECharts
      option={themedOption}
      style={{ height, width: "100%" }}
      theme="dark"
      notMerge={true}
      lazyUpdate={true}
    />
  );
};

export default EChart;
